module.exports = __webpack_public_path__ + "static/media/silver.28d9b30d.jpg";